import { useScrollReveal } from '../../../hooks/useScrollReveal';
import { stats } from '../../../mocks/testimonios';

export default function StatsSection() {
  const { ref, isVisible, style } = useScrollReveal({ threshold: 0.1, distance: 36, duration: 900 });

  return (
    <section ref={ref} className="w-full bg-white py-14 md:py-20 border-b border-brand-gray-100">
      <div className="px-6 lg:px-[7%]">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" style={style}>
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className="text-center"
              style={isVisible ? {
                opacity: 1,
                transform: 'translateY(0px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 100}ms`,
              } : {
                opacity: 0,
                transform: 'translateY(30px)',
                transition: `opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 100}ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${150 + index * 100}ms`,
                willChange: 'opacity, transform',
              }}
            >
              <div className="flex items-baseline justify-center">
                <span className="font-serif text-brand-black text-[clamp(2.5rem,4vw,3.5rem)] font-semibold leading-none">
                  {stat.value}
                </span>
                {stat.suffix && (
                  <span className="font-sans text-brand-gray-400 text-sm ml-1">
                    {stat.suffix}
                  </span>
                )}
              </div>
              <p className="font-sans text-brand-gray-500 text-sm mt-2">
                {stat.label}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}